import InvestorFeeService from '../services/investorFee.service';
// import moment from 'moment';

export const investorFee = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    getAllInvestors({ commit }) {
      return InvestorFeeService.getAllInvestors().then(
        resp => {
          commit('dummyConsole', "getAllInvestors - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getAllInvestors - error");
          return Promise.reject(error);
        }
      );
    },

    getInvestor({ commit }, investorId) {
      return InvestorFeeService.getInvestor(investorId).then(
        resp => {
          commit('dummyConsole', "getInvestor - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getInvestor - error");
          return Promise.reject(error);
        }
      );
    },

    createFee({ commit }, jnl) {
      console.log(jnl)

      return InvestorFeeService.createFee(jnl).then(
        resp => {
          commit('dummyConsole', "createFee - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "createFee - error");
          return Promise.reject(error);
        }
      );
    },

    updateFee({ commit }, { jnlId, updateJnl }) {
      console.log({ jnlId, updateJnl })

      return InvestorFeeService.updateFee(jnlId, updateJnl).then(
        resp => {
          commit('dummyConsole', "updateFee - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "updateFee - error");
          return Promise.reject(error);
        }
      );
    },

    deleteFee({ commit }, jnlId) {
      return InvestorFeeService.deleteFee(jnlId).then(
        resp => {
          commit('dummyConsole', "deleteFee - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "deleteFee - error");
          return Promise.reject(error);
        }
      );
    },

  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    }
  }
};